import React from "react";
function SocialButton({ href, icon: Icon, theme }) {
  if (!href || !Icon) return null;

  const isExternal =
    href.startsWith("http://") ||
    href.startsWith("https://");

  return (
    <a
      href={href}
      target={isExternal ? "_blank" : undefined}
      rel={
        isExternal
          ? "noopener noreferrer"
          : undefined
      }
      className={`
        flex
        h-14
        w-14
        items-center
        justify-center
        rounded-full
        border
        ${theme.swatches.light.border}
        bg-white/70
        ${theme.swatches.primary.text}
        shadow-sm
        backdrop-blur-sm
        transition-all
        duration-300
        hover:-translate-y-1
        hover:scale-110
      `}
    >
      <Icon size={24} />
    </a>
  );
}
export default function Card1({ data }) {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#111]">
      {/* Phone / Card Container */}
      <div className={`relative min-h-screen w-full max-w-[430px] overflow-hidden ${data?.selectedTheme?.swatches?.primary.bg} ${data?.selectedTheme?.swatches?.light?.text}`}>
        
     
        {/* Background subtle light effect */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute left-[-30%] top-[-10%] h-[70%] w-[80%] rotate-[-12deg] bg-white/[0.04]" />
          <div className="absolute right-[-20%] top-[25%] h-[60%] w-[50%] rotate-[10deg] bg-white/[0.025]" />
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center px-8 pt-20 h-[600px] overflow-y-auto">
          
          {/* Brand Logo */}
          <div className="text-center">
            <h1
              className={`font-serif text-[28px] leading-[0.75] tracking-[5px] ${data?.selectedTheme?.swatches?.light?.text}`}
              style={{ fontFamily: "Times New Roman, serif" }}
            >
              {data?.displayName}
            </h1>

            <p className={`mt-5 text-[20px] font-light tracking-[8px] ${data?.selectedTheme?.swatches?.light?.text}`}>
              {data?.tagline}
            </p>
          </div>

          {/* Buttons */}
           {data.filteredLinks.length > 0 && (
          <div className="mt-20 flex w-full flex-col gap-4">

            {data.filteredLinks.map(
              (link) => {
                const Icon =
                  link.icon;

                let href = data?.platformLinks?.[link.id];

                    if (link.id === "phone" && href) {
                      href = `tel:${href}`;
                    }

                    if (link.id === "email" && href) {
                      href = `mailto:${href}`;
                    }

                if (
                  !href ||
                  !Icon
                ) {
                  return null;
                }

                const isExternal =
                  href.startsWith(
                    "http://"
                  ) ||
                  href.startsWith(
                    "https://"
                  );

                return (
                  <a
                    key={link.id}
                    href={href}
                    target={
                      isExternal
                        ? "_blank"
                        : undefined
                    }
                    rel={
                      isExternal
                        ? "noopener noreferrer"
                        : undefined
                    }
                     className={`flex h-[50px] w-full items-center justify-center rounded-full border-2 ${data?.selectedTheme?.swatches?.secondary?.border} text-[18px] font-medium tracking-[5px] ${data?.selectedTheme?.swatches?.light?.text} transition ${data?.selectedTheme?.swatches?.light?.hover?.bg} ${data?.selectedTheme?.swatches?.primary?.hover?.text}`}
           
                  >



                    {/* =================================
                        TEXT
                    ================================= */}

                        {link.title ||
                          link.label}
                   
                    
                  </a>
                );
              }
            )}

          </div>
        )}


           {data.socialLinks.length > 0 && (
          <div
            className="
              mt-10
              flex
              flex-wrap
              items-center
              justify-center
              gap-4
              mb-40
            "
          >

            {data.socialLinks.map(
              (link) => {

                const Icon =
                  link.icon;

                const href =
                  data?.platformLinks?.[
                    link.id
                  ];

                if (
                  !href ||
                  !Icon
                ) {
                  return null;
                }

                return (
                  <SocialButton
                    key={link.id}
                    href={href}
                    icon={Icon}
                    theme={data.selectedTheme}
                  />
                );
              }
            )}

          </div>
        )}
        </div>

        {/* Bottom White Background */}
        <div className="absolute bottom-0 left-0 h-[200px] w-full bg-[#f4f3f0]" />

        {/* Large Profile Image */}
        <div className="absolute bottom-[-50px] left-1/2 z-20 h-[400px] w-[250px] -translate-x-1/2 overflow-hidden rounded-t-[160px]">
          <img
            src={data?.photo?.url}
            alt={data?.displayName}
            className="h-full w-full object-cover object-center"
          />
        </div>

        {/* Glass overlay */}
        <div className="pointer-events-none absolute inset-0 z-30 bg-gradient-to-br from-white/[0.08] via-transparent to-transparent" />
      </div>
    </div>
  );
};
